import React from "react";
import EtatsDesLieux from "./EtatsDesLieux";

export default function Referent() {
  return (
    <div className="space-y-8" data-testid="referent-page">
      <div data-testid="referent-edl-space">
        <EtatsDesLieux />
      </div>
    </div>
  );
}
